var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCinema = function SvgCinema(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cinema_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M23.856 12.332a.98.98 0 0 0-1.356-.347l-3.288 1.904-.837.49v4.558l.78.462c.028 0 .028.029.057.029l3.23 1.875a.9.9 0 0 0 .549.173c.548 0 .98-.433.98-.981V16.63l.03-3.808c0-.173-.03-.346-.145-.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.644 10.86A4.64 4.64 0 0 0 9.29 6.217a4.64 4.64 0 0 0-4.645-4.644A4.64 4.64 0 0 0 0 6.216c-.029 2.568 2.077 4.645 4.644 4.645m0-6.547c1.068 0 1.904.865 1.904 1.903A1.9 1.9 0 0 1 4.644 8.12a1.92 1.92 0 0 1-1.903-1.904c-.03-1.067.836-1.903 1.903-1.903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M16.414 11.12a5.5 5.5 0 0 1-2.481.606 5.4 5.4 0 0 1-3-.894H7.645a5.4 5.4 0 0 1-3 .894c-.895 0-1.731-.202-2.481-.606a2.26 2.26 0 0 0-1.125 1.933v7.038a2.345 2.345 0 0 0 2.336 2.337h11.856a2.345 2.345 0 0 0 2.336-2.337v-7.038c-.028-.808-.49-1.558-1.153-1.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.933 10.86a4.64 4.64 0 0 0 4.644-4.644 4.64 4.64 0 0 0-4.644-4.644 4.64 4.64 0 0 0-4.644 4.644 4.64 4.64 0 0 0 4.644 4.645m0-6.547c1.067 0 1.904.865 1.904 1.903a1.9 1.9 0 0 1-1.904 1.904 1.92 1.92 0 0 1-1.904-1.904c0-1.067.837-1.903 1.904-1.903"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cinema_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCinema;